import { Alert } from "antd";
import { AlertProps } from "antd/lib/alert";
import React from "react";
import styled, { createGlobalStyle } from "styled-components";

export type Props = AlertProps & {
  readonly timeout?: number;
  readonly onClose?: () => void;
};

export const Toast = ({
  description,
  message = "Error",
  type = "error",
  timeout = 15000,
  onClose = () => {},
  closable = true,
  className,
  style,
}: Props) => {
  const [visible, setVisible] = React.useState(true);
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      onToastClose();
    }, timeout);
    return () => clearTimeout(timer);
  }, []);

  const onToastClose = () => {
    onClose();
  };

  return (
    <Container style={{ display: `${visible ? "flex" : "none"}`, ...style }}>
      <Alert
        message={message}
        description={description}
        type={type}
        showIcon
        closable={closable}
        className={className}
        onClose={onToastClose}
      />
    </Container>
  );
};

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: 10px auto;
  width: 100%;
  display: flex;
  justify-items: center;
  justify-content: space-around;
  z-index: 200;
`;

export namespace AntOverride {
  export const Component = createGlobalStyle`
  .ant-message-custom-content {
    display: flex;
  }
`;
}
